export default __webpack_public_path__ + "static/media/happy_team.dea2ae82.jpg";